const focusableElements = `
  a[href]:not([disabled]),
  button:not([disabled]),
  textarea:not([disabled]),
  input[type='text']:not([disabled]),
  input[type='radio']:not([disabled]),
  input[type='checkbox']:not([disabled]),
  select:not([disabled])
`;

export default class TrapFocus {
  constructor(el) {
    this.el = el;
    this.focusableEls = this.el.querySelectorAll(`${focusableElements}`);
    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
    this.addTrapFocus = this.addTrapFocus.bind(this);

    this.createCurrentElementAnchor();
  }

  createDocumentAnchor() {
    let anchor;

    if (!document.querySelector('body > button.sr-only')) {
      anchor = this.createAnchor();
      const skipToContent = document.querySelector('.skip-to-content');
      document.querySelector('body').insertBefore(anchor, skipToContent);
    } else anchor = document.querySelector('body > button.sr-only');

    anchor.focus();
  }

  createCurrentElementAnchor() {
    if (this.el.querySelector('button.sr-only')) return;
    const anchor = this.createAnchor();
    this.focusableEls[0].parentNode.insertBefore(anchor, this.focusableEls[0]);
    this.focusableEls = this.el.querySelectorAll(`${focusableElements}`);
  }

  createAnchor() {
    const anchor = document.createElement('button');
    anchor.classList.add('sr-only');
    anchor.setAttribute('tabindex', '0');
    anchor.setAttribute('title', 'anchor');
    anchor.type = 'button';

    return anchor;
  }

  addTrapFocus(e) {
    const lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    const isTabPressed = e.key === 'Tab';
    if (!isTabPressed) return;

    if (document.activeElement === lastFocusableEl) {
      this.focusableEls[0].focus();
    }
  }

  init(noDestroy = false) {
    this.noDestroy = noDestroy;
    this.focusableEls[0].focus();
    document.addEventListener('keydown', this.addTrapFocus);
  }

  destroy(el = null) {
    document.removeEventListener('keydown', this.addTrapFocus);
    if (el) {
      el.focus();
    } else if (!this.noDestroy) this.createDocumentAnchor();
  }
}
